import React, { useEffect, useState } from "react";
import Select from "../../../form/select/Select";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllStates } from "../../../../redux/slice/staff/staffSlice";
import moment from "moment";
import * as Yup from "yup";
import { useFormik } from "formik";
import PhoneInput from "react-phone-number-input";
import { FileUploader } from "react-drag-drop-files";
import useFileUpload from "../../../../utils/hooks/useFileUpload";
import { updateCustomerPersonalInfo } from "../../../../redux/slice/customer/customerSlice";
import { ClipLoader } from "react-spinners";
import { useSignature } from "./../../../../utils/hooks/useSignature";
import { FcCheckmark } from "react-icons/fc";

const gender = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
];
const marital = [
  { id: "single", name: "Single" },
  { id: "married", name: "Married" },
  { id: "divorced", name: "Divorced" },
  { id: "widowed", name: "Widowed" },
];

const PersonalInformation = ({ data, data1 }) => {
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const [editCustomer, setEditCustomer] = useState();
  const [editing, setEditing] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  // const [error, setError] = useState({})
  const [imageUrl, setImageUrl] = useState({ passport: "" });
  const [selectedFile, setSelectedFile] = useState("");

  const dispatch = useDispatch();
  const {
    value: sign,
    Signature,
    clearSignature,
    saveSignature,
  } = useSignature(220, 100);

  const { fileUrl, singleFileUpload } = useFileUpload();

  const { allStates } = useSelector((state) => state.staff);

  const onSubmit = (values) => {
    if (!isUploading) {
      let payload = {
        ...values,
        passport: fileUrl,
        id: data.id,
        customer_signature: sign || data?.customer_signature,
      };
      dispatch(updateCustomerPersonalInfo(payload));
    }
  };

  const validationScehma = Yup.object().shape({
    state_of_origin: Yup.string("State of Origin must be a string").required(
      "State of Origin cannot be blank"
    ),
    first_name: Yup.string("First Name must be a string").required(
      "First Name cannot be blank"
    ),
    last_name: Yup.string("Last Name must be a string").required(
      "Last Name cannot be blank"
    ),
    gender: Yup.string("Gender must be a string").required(
      "Gender cannot be blank"
    ),
    marital_status: Yup.string("Marital status must be a string").required(
      "Marital status cannot be blank"
    ),
    dob: Yup.string("Date of birth must be a string").required(
      "Date of birth cannot be blank"
    ),
    phone_no: Yup.string("Phone number must be a string").required(
      "Phone number cannot be blank"
    ),
    residential_address: Yup.string(
      "Residential address must be a string"
    ).required("Residential address cannot be blank"),
    // email: Yup.string("Email must be a string").required(
    //   "Email cannot be blank"
    // ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: data?.first_name || "",
      last_name: data?.last_name || "",
      state_of_origin: data?.state_of_origin || "",
      gender: data?.gender || "",
      marital_status: data?.marital_status || "",
      dob: data?.dob || "",
      phone_no: data1?.phone_number || "",
      residential_address: data1?.residential_address || "",
      email: data1?.email || "",
      middle_name: data?.middle_name || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  const genderData = gender?.map((role) => {
    return {
      label: role.name,
      value: role.id,
    };
  });

  const maritalData = marital?.map((role) => {
    return {
      label: role.name,
      value: role.id,
    };
  });

  const allStatesData = allStates?.map((state) => {
    return {
      label: state.name,
      value: state.name,
    };
  });

  const handleClose = () => {
    values.first_name = data?.first_name;
    values.last_name = data?.last_name;
    values.state_of_origin = data?.state_of_origin;
    values.gender = data?.gender;
    values.marital_status = data?.marital_status;
    values.dob = data?.dob;
    values.phone_no = data1?.phone_number;
    values.residential_address = data1?.residential_address;
    values.email = data1?.email;
    values.middle_name = data?.middle_name;
  };

  const fileTypes = ["JPG", "PNG", "JPEG", "PDF", "DOC", "DOCX"];

  const handleFileChange = (file) => {
    setIsUploading(true);
    setSelectedFile(file);
    singleFileUpload(file);
  };

  useEffect(() => {
    dispatch(fetchAllStates());
  }, [dispatch]);

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
      setImageUrl({ ...imageUrl, passport: fileUrl });
    }
  }, [fileUrl]);

  useEffect(() => {
    setEditCustomer(
      user_permissions?.some(
        (permission) => permission.name === "edit customer - individual"
      )
    );
  }, [user_permissions]);

  return (
    <>
      <form
        className='border p-3 rounded-3 my-1 position-relative'
        onSubmit={handleSubmit}
      >
        <h4 className='fw-semibold text-primary-1 bg-white position-absolute profile-title'>
          Personal Information
        </h4>
        <div className='row'>
          <div className='col-sm-6 col-md-9'>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      First Name
                    </label>
                    {!editing ? (
                      <p>{data?.first_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm mb-1'
                          name='first_name'
                          value={values.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.first_name && touched?.first_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.first_name + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='lastname' className='fw-bold pb-1'>
                      Last Name
                    </label>
                    {!editing ? (
                      <p>{data?.last_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm mb-1'
                          name='last_name'
                          value={values.last_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.last_name && touched?.last_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.last_name + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      Middle Name
                    </label>
                    {!editing ? (
                      <p>{data?.middle_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm mb-1'
                          name='middle_name'
                          value={values.middle_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.middle_name && touched?.middle_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.middle_name + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='gender' className='fw-bold pb-1'>
                      Gender
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{data?.gender}</p>
                    ) : (
                      <div>
                        <Select
                          onBlur={() => {
                            handleBlur({ target: { name: "gender" } });
                          }}
                          name='gender'
                          data={genderData}
                          value={values.gender}
                          onChange={(selectedOption) =>
                            setFieldValue("gender", selectedOption?.value)
                          }
                        />
                        {errors?.gender && touched?.gender && (
                          <p className='mb-0 text-danger'>
                            {errors?.gender + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='state_of_origin ' className='fw-bold pb-1'>
                      State of Origin
                    </label>
                    {!editing ? (
                      <p>{data?.state_of_origin}</p>
                    ) : (
                      <div>
                        <Select
                          onBlur={() => {
                            handleBlur({ target: { name: "state_of_origin" } });
                          }}
                          name='state_of_origin'
                          data={allStatesData}
                          value={values.state_of_origin}
                          onChange={(selectedOption) =>
                            setFieldValue(
                              "state_of_origin",
                              selectedOption?.value
                            )
                          }
                        />
                        {errors?.state_of_origin &&
                          touched?.state_of_origin && (
                            <p className='mb-0 text-danger'>
                              {errors?.state_of_origin + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      Date of Birth
                    </label>
                    {!editing ? (
                      <p>{moment(`${data?.dob}`).format("L")}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm mb-1'
                          type={"date"}
                          name='dob'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          defaultValue={values?.dob}
                        />
                        {errors?.state_of_origin &&
                          touched?.state_of_origin && (
                            <p className='mb-0 text-danger'>
                              {errors?.state_of_origin + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      Marital Status
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{data?.marital_status}</p>
                    ) : (
                      <div>
                        <Select
                          onBlur={() => {
                            handleBlur({ target: { name: "marital_status" } });
                          }}
                          name='marital_status'
                          data={maritalData}
                          value={values.marital_status}
                          onChange={(selectedOption) =>
                            setFieldValue(
                              "marital_status",
                              selectedOption?.value
                            )
                          }
                        />
                        {errors?.marital_status && touched?.marital_status && (
                          <p className='mb-0 text-danger'>
                            {errors?.marital_status + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='state_of_origin ' className='fw-bold pb-1'>
                      Email Address
                    </label>
                    {!editing ? (
                      <p>{data1?.email}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm '
                          type='email'
                          name='email'
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.email && touched?.email && (
                          <p className='mb-0 text-danger'>
                            {errors?.email + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-sm-6 col-md-3'>
                    <label htmlFor='lga' className='fw-bold pb-1'>
                      Phone Number
                    </label>
                    {!editing ? (
                      <p>{data1?.phone_number}</p>
                    ) : (
                      <div>
                        <PhoneInput
                          placeholder='Enter phone number'
                          value={values.phone_no}
                          // onChange={handleChange}
                          onChange={(selectedOption) =>
                            setFieldValue("phone_no", selectedOption)
                          }
                          defaultCountry='NG'
                          name='phone_no'
                          className='form-control custom-phone-input'
                          onBlur={() => {
                            handleBlur({ target: { name: "phone_no" } });
                          }}
                        />
                        {errors?.phone_no && touched?.phone_no && (
                          <p className='mb-0 text-danger'>
                            {errors?.phone_no + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-3'>
                    <label className='text-primary-1 fw-bold pb-1'>
                      Customer Id
                    </label>
                    <p>{data1?.customer_id}</p>
                  </div>
                  <div className='col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      Residential Address
                    </label>
                    {!editing ? (
                      <p>{data1?.residential_address}</p>
                    ) : (
                      <div>
                        <textarea
                          className='form-control mb-1'
                          name='residential_address'
                          value={values.residential_address}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.residential_address &&
                          touched?.residential_address && (
                            <p className='mb-0 text-danger'>
                              {errors?.residential_address + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-sm-6 col-md-3'>
            <div className='d-flex justify-content-center'>
              <span
                className={`badge ${
                  data?.status === "1" && "badge-warning-lighten"
                } ${data?.status === "2" && "badge-success-lighten"} ${
                  data?.status === "3" && "badge-danger-lighten"
                } ${
                  data?.status === "4" && "badge-secondary-lighten"
                } fw-normal rounded-4`}
                style={{
                  fontSize: "10px",
                  padding: "5px 18px",
                }}
              >
                {data?.status === "1" && "Pending Approval"}
                {data?.status === "2" && "Active"}
                {data?.status === "3" && "Rejected"}
                {data?.status === "4" && "Closed"}
              </span>
            </div>
            <div
              className='d-flex justify-content-center'
              style={{ flexDirection: "column", alignItems: "center" }}
            >
              <img
                className='p-3 w-75'
                src={`${
                  (selectedFile && URL.createObjectURL(selectedFile)) ||
                  data?.passport_url
                }`}
                alt='customer-passport'
              />
              {data?.customer_signature && !editing ? (
                <img
                  src={data?.customer_signature}
                  alt='signature'
                  style={{ width: "40px", height: "30px" }}
                />
              ) : null}
            </div>

            {editing && (
              <div
                className='d-flex flex-column align-items-center justify-content-center gap-2'
                // style={{
                //   alignItems: "center",
                //   justifyContent: "center",
                // }}
              >
                <div className='d-flex justify-content-center'>
                  <FileUploader
                    label=' Browse Passport'
                    children={
                      <span
                        className={`btn btn-sm btn-secondary mt- ${
                          isUploading ? "px-4" : "px-3"
                        }`}
                      >
                        {isUploading ? (
                          <ClipLoader color='#fffff' size={"12px"} />
                        ) : (
                          <span>Browse</span>
                        )}
                      </span>
                    }
                    handleChange={handleFileChange}
                    onDrop={handleFileChange}
                    name='file'
                    types={fileTypes}
                  />
                </div>
                {editing ? (
                  <div>
                    {Signature}
                    <div>
                      <button
                        type='button'
                        className='btn btn-sm btn-secondary mt-2'
                        onClick={() => clearSignature()}
                      >
                        Clear
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-primary mt-2 mx-2'
                        onClick={() => saveSignature()}
                      >
                        commit
                      </button>
                      {sign && (
                        <span className='ml-2'>
                          <FcCheckmark size={22} />
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-9'>
                <div className='row'>
                  <div className='col-sm-6 col-md-3'>
                    <label className='text-primary-1 fw-bold pb-1'>Agent</label>
                    <p>{data?.user_first_name + " " + data?.user_last_name}</p>
                  </div>
                  <div className='col-sm-6 col-md-3'>
                    <label className='text-primary-1 fw-bold pb-1'>
                      Office{" "}
                    </label>
                    <p className='text-capitalize'>{data?.office_name}</p>
                  </div>
                  <div className='col-sm-6 col-md-3'>
                    <label className='text-primary-1 fw-bold pb-1'>
                      {data?.status === "2" && "Acceptance Date"}
                      {data?.status === "3" && "Rejection Date"}
                      {data?.status === "4" && "Close Date"}
                    </label>
                    <p className='text-capitalize'>
                      {data?.status === "2" &&
                        moment(`${data?.approve_date}`).format("L")}
                      {data?.status === "3" &&
                        moment(`${data?.reject_date}`).format("L")}
                      {data?.status === "4" &&
                        moment(`${data?.close_date}`).format("L")}
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  {data?.status === "3" && (
                    <div className={`col-sm-6 col-md-6`}>
                      <label className='text-primary-1 fw-bold pb-1'>
                        Rejection Reason
                      </label>
                      <p>{data?.status_reason}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {editCustomer && data?.status !== "3" && (
          <div className='row'>
            <div className='d-flex justify-content-end'>
              <div>
                <button
                  type='button'
                  className={`btn btn-${
                    editing ? "warning" : "info"
                  } btn-sm mt-3 px-4 text-white`}
                  onClick={() => {
                    setEditing(editing ? false : true);
                    handleClose();
                  }}
                >
                  {editing ? "Close" : "Edit"}
                </button>
                {editing && (
                  <button
                    className='btn btn-success ms-2 btn-sm mt-3 px-4'
                    type='submit'
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default PersonalInformation;
